// useProfile hook for fetching user profile data

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/services/queryClient'
import { getUserProfile } from '@/services/profile/profileService'

interface UseProfileOptions {
  enabled?: boolean
}

export function useProfile(username: string, options: UseProfileOptions = {}) {
  const { enabled = true } = options

  return useQuery({
    queryKey: queryKeys.profile(username),
    queryFn: () => getUserProfile(username),
    enabled: enabled && !!username,
    staleTime: 60 * 1000, // 1 minute
  })
}
